import { Flex } from "@mantine/core";
import { useMediaQuery, useScrollIntoView } from "@mantine/hooks";
import NavLinkMatrix from "../NavLinkMatrix";
import { client_selected } from "../../client";
import { useTranslation } from "react-i18next";

const NavlinksFooter = () => {
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  const { scrollIntoView } = useScrollIntoView({ duration: 0 });
  const { i18n } = useTranslation();

  const footerLinks = client_selected.footerLinks;
  const footerLinksTerms = client_selected.footerLinksTerms;
  const redirectClient = client_selected.redirect;

  const languageMap: Record<string, "pt_br" | "en_us" | "es"> = {
    "pt-BR": "pt_br",
    "en-US": "en_us",
    es: "es",
  };
  const langKey = languageMap[i18n.language] || "pt_br";

  const getPathByLang = (pathObj?: {
    pt_br?: string;
    en_us?: string;
    es?: string;
  }) => {
    if (!pathObj) return redirectClient;
    return (
      pathObj[langKey] ||
      pathObj.pt_br ||
      Object.values(pathObj).find(Boolean) ||
      redirectClient
    );
  };

  const isExternal = (url: string) => /^https?:\/\//i.test(url);

  return (
    <Flex
      direction={{ base: "column" }}
      rowGap={{ base: 24, 450: 12, 991: 12 }}
      columnGap={{
        base: "unset",
        450: 20,
        1120: "50px !important",
      }}
      w="100%"
      miw={{ base: 190, 450: 380, 796: 190, 991: "380px !important" }}
      maw={{
        base: "unset",
        450: 560,
        796: "fit-content",
        991: "550px !important ",
      }}
      h={{ base: "unset", 450: 130, 796: "unset", 991: "130px !important" }}
      wrap={{
        base: "nowrap",
        450: "wrap",
        //670: "revert",
        991: "wrap !important",
      }}
      sx={{ alignContent: "space-between" }}
    >
      {footerLinksTerms && footerLinksTerms.length > 0
        ? footerLinksTerms.map((item, index) => {
            const path = getPathByLang(item.path);
            return (
              <Flex
                key={`navlinkFooter${index}`}
                w={"100%"}
                maw={{ base: "fit-content", 450: 190 }}
                mb={{
                  base: "unset",
                  991: index === 1 ? 50 : "unset",
                }}
                sx={{
                  flex: index < 2 ? 1 : 2,
                  order: isLargerThan991 ? "unset" : index < 2 ? 2 : 1,
                }}
              >
                <NavLinkMatrix
                  onClick={() => scrollIntoView({ alignment: "start" })}
                  label={item.name}
                  target={isExternal(path) ? "_blank" : "_self"}
                  to={path || redirectClient}
                  h={{ base: 44, 450: 34 }}
                />
              </Flex>
            );
          })
        : null}

      {footerLinks && footerLinks.length > 0
        ? footerLinks.map((item, index) => {
            const path = getPathByLang(item.path);
            return (
              <Flex
                key={`navlinkFooter${index}`}
                w={"100%"}
                maw={{ base: "fit-content", 450: 190 }}
              >
                <NavLinkMatrix
                  target={isExternal(path) ? "_blank" : "_self"}
                  label={item.name}
                  to={path || redirectClient}
                  h={{ base: 44, 450: 34 }}
                />
              </Flex>
            );
          })
        : null}
    </Flex>
  );
};

export default NavlinksFooter;
